// app/javascript/controllers/search_form_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    initialize() {
        this.timeout = null; // This will hold our timer
    }

    search() {
        // Clear any pending search submission
        clearTimeout(this.timeout);

        // Set a new timer to submit the form after 300ms of inactivity
        this.timeout = setTimeout(() => {
            // 'this.element' refers to the form the controller is attached to
            this.element.requestSubmit();
        }, 300);
    }

    disconnect() {
        // A good practice to clear the timer if the element is ever removed
        clearTimeout(this.timeout);
    }
}